<template>
  <div>
    <mt-header :title="$t('个人资料')" class="dl_header_white" fixed style="margin-bottom: 13px;">
      <mt-button icon="back" slot="left" @click="goback"></mt-button>
    </mt-header>
    <div class="avatar" style="text-align: center;margin: 100px auto 0;font-size: 14px;">
      <div class="" style="text-align: center;margin-bottom: 5px">
  <!--      <img class="head avatar" v-if="userInfo.avatar" :src="userInfo.avatar" style="width: 60px;height: 60px;border-radius: 50%;" />-->
  <!--      <img class="head avatar" v-else src="@/assets/img/avatar.jpg" style="width: 60px;height: 60px;border-radius: 50%;" />-->
        <img class="head avatar" :src="srcUrl" style="width: 80px;height: 80px;border-radius: 50%;" />
      </div>
      <div class="up">
        <input id="file1" name="file1" type="file" multiple="multiple" @change="fileUpload" style="height:0;width:0;z-index: -1; position: absolute;left: 10px;top: 5px;">
        <span onclick="getElementById('file1').click()" style="cursor:pointer;width: 60px;height: 60px;font-size: 12px;color:#999999;">{{$t("点击修改")}}</span>
      </div>
      <div style="margin-top: 50px;padding: 15px;">
        <ul>
          <li class="cont" @click="updateUserNickname">
            <span class="l">{{$t("昵称")}}</span>
            <span class="v" >
              <span>{{userInfo.user_nickname}}</span>
              <img src="@/assets/img/youjiantou.png" alt="" style="margin-left: 5px;width: 12px;">
            </span>

          </li>
          <li  class="cont">
            <span class="l">{{$t('ID')}}</span>
            <span class="v">{{userInfo.id}}</span>
          </li>
          <li  class="cont">
            <span class="l">{{$t('手机号')}}</span>
            <span  class="v">{{userInfo.mobile}}</span>
          </li>
          <li  class="cont">
            <span class="l">{{$t("注册时间")}}</span>
            <span class="v" >{{userInfo.create_time}}</span>
          </li>
          <li  class="cont" @click="updateUserSignature">
            <span class="l">{{$t("个性签名")}}</span>
            <span class="v">
              <span v-if="userInfo.signature.length<16">{{userInfo.signature}}</span>
              <span v-else>{{userInfo.signature.replace(userInfo.signature.substr(13), '...') }}</span>
              <img src="@/assets/img/youjiantou.png" alt="" style="margin-left: 5px;width: 12px;">
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div>

    </div>
  </div>
</template>

<script>
import {httpGetUserInfo, httpPostUserInfo} from "../../api/login";
import imageConversion from "image-conversion";
import {httpUpload} from "../../api/userCenter";
import { MessageBox } from 'mint-ui';

export default {
  name: "PersonalData",
  data(){
    return {
      userInfo:{},
      userid:0,
      imgBase:{},
      srcUrl:''
    }
  },
  created() {
  },
  mounted() {

  },
  activated() {
    this.userid = this.$route.query.id
    this.getUserInfo()
  },
  methods:{
    goback: function () {
      this.$router.back();
    },
    getUserInfo(){
      httpGetUserInfo().then(res => {
        this.userInfo = res.data
        if(res.data.avatar){
          this.srcUrl = res.data.avatar
        }else{
          this.srcUrl = '../../assets/img/avatar.jpg'
        }
        this.userInfo.create_time = this.formatDate(res.data.create_time)
      }).catch(e => {

      })
    },
    fileUpload() {
      let file = document.getElementById('file1');
      let fileName = file.value;
      let files = file.files;
      if (fileName == null || fileName == "") {
        alert("请选择文件");
      } else {
        let pos = fileName.indexOf(".")
        let fileType = fileName.substr(pos + 1, fileName.length);
        if (fileType == "jpg" || fileType == "png") {
          if (files[0]) {
            if (files[0].size < 2 * 1024 * 1024) {//小于2MB
              let formData = new window.FormData()
              formData.append('file', files[0])
              this.uploadImage(formData,file)
            }else {//超过2MB，进行压缩
              imageConversion.compressAccurately(files[0],500).then(res=>{
                let formData = new window.FormData()
                formData.append('file', res,fileName)
                this.uploadImage(formData,file)
              })
            }
          } else {
            alert("请选择要上传的图片");
          }
        } else {
          alert("上传文件类型错误！");
        }
      }
    },

    uploadImage(formData,file){
      let that = this
      httpUpload(formData)
          .then(res => {
            that.srcUrl = res.data.http_url
            let reader = new FileReader();
            reader.readAsDataURL(file.files[0]);
            reader.onload = function (e) {
              let timestamp = (new Date()).valueOf();
              that.imgBase = {id: timestamp, base64: this.result}
            }
            that.updateUserInfo({
              user_nickname:that.userInfo.user_nickname,
              signature:that.userInfo.signature,
              avatar:res.data.http_url,
              two_factor_authentication_status:that.userInfo.two_factor_authentication_status,

            })
          })
    },
    updateUserInfo(data){
      httpPostUserInfo(data).then(res => {
        this.getUserInfo()
      }).catch(e => {
      })
    },
    updateUserNickname(){
      MessageBox.prompt(' ','修改昵称',{inputPlaceholder: '请输入新昵称',inputValue:this.userInfo.user_nickname}).then(({ value, action }) => {
        if(action == 'confirm'){
          this.updateUserInfo({
            user_nickname:value,
            signature:this.userInfo.signature,
            avatar:this.userInfo.avatar,
            two_factor_authentication_status:this.userInfo.two_factor_authentication_status,
          })
        }
      });


    },
    updateUserSignature(){
      MessageBox.prompt(' ','修改个性签名',{inputPlaceholder: '请输入新个性签名',inputValue:this.userInfo.signature}).then(({ value, action }) => {
        if(action == 'confirm'){
          this.updateUserInfo({
            user_nickname:this.userInfo.user_nickname,
            signature:value,
            avatar:this.userInfo.avatar,
            two_factor_authentication_status:this.userInfo.two_factor_authentication_status,
          })
        }
      });
    },
    formatDate(now) {
      var now = new Date(now*1000)
      var year=now.getFullYear();
      var month=now.getMonth()+1;
      var date=now.getDate();
      var hour=now.getHours();
      var minute=now.getMinutes();
      var second=now.getSeconds();
      return year+"-"+month+"-"+date;
    }
  }
}
</script>

<style scoped>
.cont{
  border-bottom: solid 1px #F0F0F0;
  overflow: hidden;
  padding: 18.5px 16.5px;
}
.l{
  float: left;
  color: #333333;
}
.v{
  float: right;
  color: #999999;
}
</style>
